import React from 'react';

import { CollectionChainType } from '@app/client';

import AptosSvg from '../../svg/aptos.svg';
import EthereumSvg from '../../svg/ethereum.svg';
import PolygonSvg from '../../svg/polygon.svg';

import { Wrapper } from './styles';

interface CurrencyIconProps {
    chain?: string | CollectionChainType;
}

export const CurrencyIcon = ({ chain }: CurrencyIconProps) => {
    return (
        <Wrapper initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0 }}>
            {chain === CollectionChainType.Polygon && <img alt="poligon icon" src={PolygonSvg} title="Polygon" />}
            {chain === CollectionChainType.Aptos && <img alt="aptos icon" src={AptosSvg} title="Aptos" />}
            {chain === CollectionChainType.Ethereum && <img alt="ethereum icon" src={EthereumSvg} title="Ethereum" />}
        </Wrapper>
    );
};
